export const FIELDS = [
  ["job_number", "Move Pro Job Number *", ["job number", "job no", "job #", "job", "ref", "move pro"]],
  ["customer_name", "Customer Name *", ["name", "customer", "client"]],
  ["moving_date", "Moving Date *", ["date", "moving date", "move date"]],
  ["mobile", "Mobile", ["mobile", "phone", "contact"]],
  ["email", "Email", ["email"]],
  ["pickup_address", "Pickup Address", ["pickup", "from", "origin"]],
  ["delivery_address", "Delivery Address", ["delivery", "dropoff", "drop off", "destination"]],
  ["start_time", "Start Time", ["start time", "start", "time"]],
  ["job_type", "Job Type / Route", ["job type", "route", "type", "service"]],
  ["state", "State", ["state"]],
  ["status", "Status", ["status"]],
  ["men", "Number of Removalists", ["men", "removalists", "movers"]],
  ["truck_size", "Truck Size", ["truck capacity", "truck size", "capacity", "truck"]],
  ["truck_assigned", "Truck Assigned", ["truck number", "truck assigned", "rego"]],
  ["assigned_team", "Driver / Team", ["driver 1", "driver", "team", "crew"]],
  ["sales_person", "Booked By / Sales", ["sales", "booked by", "rep"]],
  ["emergency_contact_number", "Emergency Contact", ["emergency"]],
  ["bill_to_company", "Bill to company (account customer)", ["subcontractor", "company", "bill to", "account"]],
  ["rate", "Rate (hourly if hours given, else fixed price)", ["rate"]],
  ["estimated_hours", "Total Hours", ["total hours", "hours"]],
  ["driver_extra_amount", "Driver Extra ($)", ["driver extra"]],
  ["extra_details", "Extra Details", ["extra details"]],
  ["wrapping", "Wrapping ($)", ["wrapping"]],
  ["cash_paid", "Cash paid on the day", ["cash"]],
  ["card_paid", "Card paid on the day", ["card"]],
  ["pricing_type", "Pricing Type", ["pricing type"]],
  ["hourly_rate", "Hourly Rate", ["hourly rate", "hourly"]],
  ["fixed_price", "Fixed Price", ["fixed price", "fixed", "quote"]],
  ["price_per_m3", "Rate per m³", ["per m3", "per cubic", "m3 rate"]],
  ["cubic_metres", "Cubic Metres", ["cubic", "m3", "volume"]],
  ["callout_fee", "Call-Out Fee ($)", ["call out fee"]],
  ["additional_charges", "Additional Charges", ["company extra", "additional", "extra charges"]],
  ["deposit_amount", "Deposit Paid", ["deposit"]],
  ["deposit_method", "Deposit Method", ["deposit method", "payment method", "paid via"]],
  ["bedrooms", "Bedrooms", ["bedrooms", "beds"]],
  ["job_notes", "Job Notes", ["details", "notes", "comments"]],
  ["special_requirements", "Special Requirements", ["special", "requirements"]],
  ["internal_notes", "Internal Notes", ["internal"]],
  ["confirmation_time", "Time shown to customer", ["confirmation time", "arrival window"]],
];

export const autoMap = (columns) => {
  const used = new Set();
  const out = {};
  const norm = (s) => s.toLowerCase().replace(/[^a-z0-9 ]/g, " ").replace(/\s+/g, " ").trim();
  FIELDS.forEach(([field, , hints]) => {
    const match = columns.find((c) => !used.has(c) && hints.some((h) => norm(c) === h)) || columns.find((c) => !used.has(c) && hints.some((h) => norm(c).includes(h)));
    if (match) { out[field] = match; used.add(match); }
  });
  return out;
};

const NONE = "__none";

export const FieldMapping = ({ columns, sample, mapping, setMapping }) => (
  <div className="rounded-xl border border-slate-200 bg-white" data-testid="import-mapping">
    <div className="border-b border-slate-100 px-5 py-3.5">
      <h2 className="font-display text-base font-semibold text-[#0E1E38]">Match your spreadsheet columns</h2>
      <p className="text-xs text-slate-500">We've guessed where we could. Fields marked * are required. Leave anything you don't have as "Skip".</p>
    </div>
    <div className="grid gap-x-6 gap-y-2 p-5 md:grid-cols-2">
      {FIELDS.map(([field, label]) => (
        <div key={field} className="grid grid-cols-[1fr_1fr] items-center gap-3 border-b border-slate-50 py-1.5 text-sm" data-testid={`map-row-${field}`}>
          <div>
            <div className="font-medium text-slate-800">{label}</div>
            {mapping[field] && sample && <div className="truncate text-xs text-slate-400">e.g. {String(sample[mapping[field]] ?? "")}</div>}
          </div>
          <select value={mapping[field] || NONE} onChange={(e) => setMapping({ ...mapping, [field]: e.target.value === NONE ? "" : e.target.value })} data-testid={`map-select-${field}`}
            className={`h-9 rounded-md border px-2 text-sm ${mapping[field] ? "border-sky-300 bg-sky-50" : "border-slate-200 bg-white text-slate-500"}`}>
            <option value={NONE}>— Skip —</option>
            {columns.map((c) => <option key={c} value={c}>{c}</option>)}
          </select>
        </div>
      ))}
    </div>
  </div>
);
